import React, { useRef, useState } from 'react';

import { ValueBox, ValueStepper } from '@candu-ai/craft/ui';

interface Props {
  columnGap: string | undefined;
  setCss: (css: Record<string, any>) => void;
}

export const ColumnGapStepper = ({ columnGap, setCss }: Props) => {
  const inputRef = useRef<HTMLInputElement>();
  const [inputValue, setInputValue] = useState<number | undefined>(
    typeof columnGap !== 'undefined' ? parseInt(columnGap, 10) : columnGap,
  );

  return (
    <ValueBox label="Space between">
      <ValueStepper
        ref={inputRef}
        name="column-gap"
        format="inline"
        editable
        step={1}
        maxValue={40}
        valueSuffix="px"
        onChange={(newValue?: number) => {
          setInputValue(newValue);
          // only trigger change when there is no value or the value is within the accepted range
          if (typeof newValue === 'undefined' || (newValue >= 0 && newValue <= 40)) {
            setCss({ columnGap: typeof newValue !== 'undefined' ? `${newValue}px` : newValue });
          }
        }}
        onBlur={() => {
          if (typeof inputValue === 'undefined') {
            // if the value was deleted at the time of blurring, reflect actual value in the input
            setInputValue(0);
          }
        }}
        value={inputValue}
      />
    </ValueBox>
  );
};
